module.exports = __webpack_public_path__ + "img/blob_2.caa23e05.svg";